<div>
    <router-outlet></router-outlet>
</div>

<div #spinnerPortal>
  @if (isLoading$ | async) {
    <div class="global-spinner-overlay">
      <loading-spinner></loading-spinner>
    </div>
  }
</div>

<!-- Bootstrap 3 CDN + CDN jQuery removed: Bootstrap was retired in favour of the inlined subset in
     styles.css + Tailwind (see 'final removal'), and BS3's unlayered rules were fighting the Tailwind
     layer cascade. jQuery is bundled via angular.json. -->
<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

<script type="text/javascript"
  src="https://unpkg.com/@webcomponents/webcomponentsjs@2.2.10/webcomponents-bundle.js"></script>
<script type="text/javascript"
  src="https://unpkg.com/@webcomponents/webcomponentsjs@2.2.10/custom-elements-es5-adapter.js"></script>
<script type="text/javascript" src="custom-element.js"></script>

 